/**
 * Round a number to a given precision using half-away-from-zero rounding.
 * This implements consistent tie-breaking for values like 1.005 or -1.005,
 * and mitigates common floating point issues in JavaScript.
 */
export const round = (value: number, precision = 0) => {
	if (!Number.isInteger(precision)) {
		throw new TypeError("Precision must be an integer.");
	}

	const multiplier = 10 ** precision;
	// eslint-disable-next-line no-restricted-properties -- Math.round is the only function that can be used to round numbers in JS
	return Math.round(value * multiplier * (1 + Number.EPSILON)) / multiplier;
};
